import { createSlice } from '@reduxjs/toolkit';
import {
  fetchKulaBlueprint,
  fetchOrgBlueprint,
  fetchBlueprintById,
  fetchBlueprintByIdInBackground,
} from './actions';

const initialState = {
  kulaBlueprint: [],
  isKulaBlueprintLoading: true,

  orgBlueprint: [],
  isOrgBlueprintLoading: true,

  bluePrints: {},

  search: {
    term: null,
  },
};

const { reducer, actions } = createSlice({
  name: 'blueprint',
  initialState,

  reducers: {
    applySearchTerm: (state, { payload }) => {
      state.search.term = payload?.searchTerm;
    },

    addBlueprintStep: (state, action) => {
      const { bluePrints } = state;
      const { data: newOutreachStep, blueprintId } = action.payload;

      const currBluePrint = bluePrints[blueprintId];
      const outreach = currBluePrint?.outreach;
      const updatedSteps = outreach?.steps?.length
        ? [...outreach.steps, newOutreachStep]
        : [newOutreachStep];
      outreach.steps = updatedSteps;
      state.data = bluePrints;
    },
  },

  extraReducers: {
    [fetchKulaBlueprint.pending]: (state) => {
      state.isKulaBlueprintLoading = true;
    },

    [fetchKulaBlueprint.fulfilled]: (state, { payload }) => {
      state.kulaBlueprint = payload?.data || [];
      state.isKulaBlueprintLoading = false;
    },

    [fetchOrgBlueprint.pending]: (state) => {
      state.isOrgBlueprintLoading = true;
    },

    [fetchOrgBlueprint.fulfilled]: (state, { payload }) => {
      state.orgBlueprint = payload?.data || [];
      state.isOrgBlueprintLoading = false;
    },

    [fetchBlueprintById.pending]: (state, { meta: { arg } }) => {
      const {
        blueprint: { id },
      } = arg;
      state.bluePrints[id] = { isLoading: true };
    },

    [fetchBlueprintById.fulfilled]: (state, { payload, meta: { arg } }) => {
      const {
        blueprint: { id },
      } = arg;
      state.bluePrints[id] = { isLoading: false, ...payload };
    },

    [fetchBlueprintByIdInBackground.fulfilled]: (
      state,
      { payload, meta: { arg } }
    ) => {
      const {
        blueprint: { id },
      } = arg;
      state.bluePrints[id] = { isLoading: false, ...payload };
    },
  },
});

export const { applySearchTerm, addBlueprintStep } = actions;
export default reducer;
